import React, { useRef, useContext } from 'react';
import ReactPlayer from 'react-player';
import MahuaDesi from '../images/mahuadesi.png';
import { Contextone } from './Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { logAnalyticsEvent } from "./Script.js";

const ReactPlay = () => {

    const { moviename, encoded } = useParams(); 

    const decodeComponent = () => {
        if (!encoded || typeof encoded !== "string") {
            console.error("Invalid or missing encoded value:", encoded);
            return "";
        }
    
        try {
            return atob(encoded); 
        } catch (error) {
            console.error("Decoding failed for encoded value:", encoded, error);
            return "";
        }
    };
      
    let [id, type_id, video_type, upcoming_type] = decodeComponent(encoded).split('-');
    let vidSplit = moviename.split("/");
    let vidName = vidSplit.pop();
    

    const history = useHistory();
    const countercontext = useContext(Contextone);
    const location = useLocation();
    const { url } = location.state || {};
    const videoDataRef = useRef({
        videoid: vidName,
        durationWatched: 0,
        events: [],
        startTime: null,
    });

    const handlePlay = () => {
        const videoData = videoDataRef.current;
        videoData.startTime = Date.now();
        videoData.videoid = id;
        videoData.events.push({ event: 'play', timestamp: new Date().toISOString() });
        logAnalyticsEvent('play', {
            // name,
            videoname : vidName,
            timestamp: new Date().toISOString(), 
        });
    };

    const handlePauseOrEnd = (event) => {
        const videoData = videoDataRef.current;
        if (videoData.startTime) {
            const watchTime = (Date.now() - videoData.startTime) / 1000;
            videoData.durationWatched += watchTime;
            videoData.videoid = id;
            videoData.events.push({ event: event, timestamp: new Date().toISOString(), watchTime });
            
            logAnalyticsEvent(event, {
                videoname : vidName,
                timestamp: new Date().toISOString(), 
                watchTime
            });
            videoData.startTime = null;
        }
    };

    return (
        <>
            {url ? (
                <div>
                    <div className="top-left-button">
                        <button
                            onClick={() => history.goBack()}
                            style={{
                                background: 'none',
                                border: 'none',
                                fontSize: '24px',
                                color: '#000',
                                cursor: 'pointer',
                                zIndex: '1',
                                position: 'absolute',
                            }}
                        >
                            <FontAwesomeIcon icon={faArrowLeft} style={{ color: 'white' }} />
                        </button>
                        {countercontext.isDomain === 'mahuaplay.ottsnap.in' && (
                            <img src={MahuaDesi} height="67px" alt="Logo" />
                        )}
                    </div>
                    <div className="player-wrapper">
                        <ReactPlayer
                            className="react-player"
                            url={url}
                            playing={true}
                            controls={true}
                            playsinline={true}
                            width="100vw"
                            height="97vh"
                            onPlay={handlePlay}
                            onPause={() => handlePauseOrEnd('pause')}
                            onEnded={() => handlePauseOrEnd('ended')}
                            onError={(e) => console.error('Error playing video:', e)}
                        />
                    </div>
                </div>
            ) : (
                <div>
                    {id && type_id && parseInt(video_type) === 0
                        ? history.push('/')
                        : history.push(`/home/${moviename}/${encoded}`)}
                </div>
            )}
        </>
    );
};

export default ReactPlay;
